(function () {
  function initFooter(footer) {
    if (!footer || footer.dataset.dmAccordionReady === 'true') return;

    footer.dataset.dmAccordionReady = 'true';
    footer.addEventListener('click', function (event) {
      var button = event.target.closest('.dm-footer-dropdown-toggle');

      if (!button || !footer.contains(button)) return;
      if (!window.matchMedia('(max-width: 767px)').matches) return;

      var menu = button.closest('.dm-footer-menu');

      if (!menu) return;

      var isOpen = menu.classList.toggle('is-open');
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function initFooters(scope) {
    var root = scope || document;

    if (root.matches && root.matches('.dm-footer-custom')) initFooter(root);
    root.querySelectorAll('.dm-footer-custom').forEach(initFooter);
  }

  function ready() {
    initFooters(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFooters(event.target);
  });
})();
